module.exports = __webpack_public_path__ + "static/media/adsk-facilities-sf.3efb2155.png";